var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7071 5.30241C15.3166 4.91189 14.6834 4.91189 14.2929 5.30241L8.29289 11.3024C7.90237 11.6929 7.90237 12.3261 8.29289 12.7166L14.2929 18.7166C14.6834 19.1072 15.3166 19.1072 15.7071 18.7166C16.0976 18.3261 16.0976 17.6929 15.7071 17.3024L10.4142 12.0095L15.7071 6.71663C16.0976 6.3261 16.0976 5.69294 15.7071 5.30241Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.0e58443e779ab297bbbc39c1edd4a8a2.svg";
export { ForwardRef as ReactComponent };